import React, {useEffect, useState} from "react";
import {t} from "../../../shared-services/translate";
import useProductPrice from "../useProductPrice";
import useWindowTools from "../../../react-hooks/useWindowTools";

const PriceTagPDP = (props) => {
  const {product} = props;
  const {isMobile} = useWindowTools();

  const [ffProduct, setFfproduct] = useState(false);

  const {
    price,
    splitPrice,
    strikeoutPrice,
    pricePerUnit,
    pricePerUnitLabel,
    currency,
    useDiscount,
    StrikeoutPrice
  } = useProductPrice(product);

  useEffect(() => {
    setFfproduct(strikeoutPrice && product?.eligible_for_ffamily);
  }, [strikeoutPrice]);

  return <div
    className={`
      flex
      justify-content-flex-start
      align-items-center
      ${isMobile ? "flex-wrap-wrap-reverse" : "gap-20"}
    `}
  >
    <div className="flex flex-direction-column">
      {ffProduct && useDiscount && !isMobile && <div
        className='text-color-orange'
        style={{marginTop: "-20px"}}
      >
        {t("farmy_family.price")}
      </div>}

      <div className='flex justify-content-space-between align-items-center'>
        <div className="main-price-wrapper">
          <div className={`
          main-price
          font-weight-900
          flex
          justify-content-flex-start
          ${useDiscount ? "text-color-orange" : ""}
        `}
          >
            <span
              className={"flex justify-content-center align-items-center"}
              style={{
                fontSize: isMobile ? "34px" : "38px",
                lineHeight: isMobile ? "0.9em" : null
              }}>
              <span className='margin-right-5'>{currency}</span>
              {splitPrice(price)[0]}
              .
            </span>
            <span
              className='font-size-h2-mobile'
              style={{marginLeft: "-0.2em", marginTop: isMobile ? "-0.15em" : "0.3em"}}
            >
              {splitPrice(price)[1] || "00"}
            </span>
          </div>
          {pricePerUnit &&
            <div className="small text-color-dimmed font-weight-600">
              {currency} {pricePerUnit} / {pricePerUnitLabel}
            </div>
          }
        </div>
      </div>
    </div>

    {strikeoutPrice && useDiscount && <div className={isMobile ? "flex align-items-baseline gap-10" : ""}>
      {ffProduct && useDiscount && isMobile && <div
        className='text-color-orange'
        style={{marginTop: "-20px"}}
      >
        {t("farmy_family.price")}
      </div>}

      <StrikeoutPrice
        className="text-color-dimmed margin-top-10"
        price={strikeoutPrice}
        currency={currency}
      />
    </div>
    }

    {strikeoutPrice && !useDiscount &&
      <div className={`${isMobile ? "flex gap-5" : ""}`}>
        <div className='text-color-orange text-small'>
          {t("farmy_family.price")}
        </div>

        <div className="text-color-orange font-weight-900">
          {currency} &nbsp;
          {strikeoutPrice}
        </div>
      </div>
    }
  </div>;
};

export default PriceTagPDP;
